import { render, staticRenderFns } from "./attachment-list-fields.vue?vue&type=template&id=b7d1e6c0&scoped=true&lang=pug"
import script from "./attachment-list-fields.vue?vue&type=script&lang=js"
export * from "./attachment-list-fields.vue?vue&type=script&lang=js"
import style0 from "./attachment-list-fields.vue?vue&type=style&index=0&id=b7d1e6c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d1e6c0",
  null
  
)

export default component.exports